@if (visible) {
  <div class="rb-wrap">
    <a class="toolbar-toggle rb-chip" (click)="toggle()" data-bs-toggle="tooltip"
       title="Overdue rentals" [class.rb-alert]="count() > 0">
      <span><i class="fa fa-bell fa-2x rb-icon"></i></span>
      @if (count() > 0) {
        <span class="rb-badge">{{ count() > 99 ? '99+' : count() }}</span>
      }
    </a>

    @if (open()) {
      <div class="rb-backdrop" (click)="close()"></div>
      <div class="rb-panel" role="dialog" aria-label="Overdue rentals">
        <div class="rb-panel-header">
          <b><i class="fa fa-bell" aria-hidden="true"></i> Overdue rentals</b>
          <button type="button" class="btn-close btn-close-sm ms-auto" aria-label="Close" (click)="close()"></button>
        </div>

        @if (count() === 0) {
          <div class="rb-note">Nothing overdue — every rented item is within its return window.</div>
        } @else if (loadingRows()) {
          <div class="rb-note">Loading…</div>
        } @else {
          <ul class="rb-list">
            @for (row of rows(); track row.detailId) {
              <li class="rb-row">
                <div class="rb-row-main">
                  <span class="rb-item">{{ row.itemName }}</span>
                  <span class="rb-qty">x{{ row.quantity }}</span>
                  <span class="rb-days">{{ row.daysOverdue }} day{{ row.daysOverdue === 1 ? '' : 's' }} overdue</span>
                </div>
                <div class="rb-row-sub">
                  {{ row.invoiceNo }} · {{ row.devoteeName || '-' }}
                  @if (row.phone) { <span> · {{ row.phone }}</span> }
                  @if (+row.depositAmount > 0) { <span class="rb-deposit"> · deposit ₹{{ row.depositAmount }}</span> }
                </div>
              </li>
            }
          </ul>
        }

        <button type="button" class="rb-open-enquiry" (click)="openEnquiry()">
          Open Rental Enquiry <i class="fa fa-angle-right" aria-hidden="true"></i>
        </button>
      </div>
    }
  </div>
}
